import MDBox from 'components/MDBox'
import Switch from '@mui/material/Switch'
import { useAppServices } from 'hook/services'
import { useEffect, useState, useRef } from 'react'
import EditModal from '../../EditModal'
import toast from 'react-hot-toast'
import { useUserInfo } from 'context/user'
import { useAuth } from 'hook/auth'

export default function useAppData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(true)
  const [search, setSearch] = useState('')
  const typingTimeoutRef = useRef(null)
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    totalPages: 0,
    totalUsers: 0,
  })

  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  })

  const getAppTypes = async (page = 1, limit = 10, searchTerm = search) => {
    setLoader(true)
    try {
      const params = {
        page,
        limit,
        toaster: false,
        startDate: dateRange.startDate ? dateRange.startDate.toISOString() : 'null',
        endDate: dateRange.endDate ? dateRange.endDate.toISOString() : 'null',
        search: searchTerm?.trim() || '',
      }

      const query = Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')

      const { response } = await AppService.auth.getallUsers({ query })

      if (response?.success) {
        setList(response.data || [])
        setPagination({
          page: response.pagination?.currentPage || page,
          limit: response.pagination?.usersPerPage || limit,
          totalPages: response.pagination?.totalPages || 0,
          totalUsers: response.pagination?.totalUsers || 0,
        })
      } else {
        setList([])
      }
    } catch (err) {
      console.error('❌ Error fetching listings:', err)
      setList([])
    } finally {
      setLoader(false)
    }
  }

  const onLoad = () => {
    getAppTypes(pagination.page, pagination.limit)
  }


  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this listing?')) return
    try {
      const { response, error } = await AppService.auth.delete({ payload: { userId: id } })
      if (response?.success) {
        toast.success('Listing deleted successfully!')
        getAppTypes(pagination.page, pagination.limit)
      } else {
        toast.error(response?.message || 'Failed to delete listing')
        console.error('Delete failed:', error)
      }
    } catch (err) {
      console.error('Error deleting listing:', err)
      toast.error('Something went wrong while deleting listing')
    }
  }



  const handleLoginAs = async (userId) => {
    const res = await AppService.auth.loginuser({
      payload: { userId, role: "Admin" },
    });

    if (res?.response?.success) {
      window.location.href = `https://aloca.com.au/?token=${encodeURIComponent(res.response.token)}`;
    } else {
      toast.error(res?.response?.message || "Login as user failed");
    }
  };






  useEffect(() => {
    getAppTypes(1, pagination.limit)
  }, [dateRange])

  useEffect(() => {
    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current)
    typingTimeoutRef.current = setTimeout(() => {
      getAppTypes(1, pagination.limit, search)
    }, 1000)

    return () => clearTimeout(typingTimeoutRef.current)
  }, [search])

  const handlePageChange = (newPage) => {
    getAppTypes(newPage, pagination.limit, search)
  }

  const handleLimitChange = (newLimit) => {
    getAppTypes(1, newLimit, search)
  }

  const handleSearch = () => {
    getAppTypes(1, pagination.limit, search)
  }

  const truncateText = (text, wordLimit = 8) => {
    if (!text) return ''
    const words = text.split(' ')
    return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : text
  }

  return {
    loader,
    handleRefresh: onLoad,
    setDateRange,
    dateRange,
    pagination,
    handlePageChange,
    handleLimitChange,
    search,
    setSearch,
    handleSearch,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'display_name' },
        { Header: 'Email', accessor: 'email' },
        { Header: 'Role', accessor: 'role' },
        { Header: 'Stripe Account', accessor: 'stripeAccount' },
        { Header: 'Created At', accessor: 'createdAt' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        display_name: data.display_name,
        email: data.email,
        role: data.role === 'creative' ? 'Creative' : 'Host',
        stripeAccount: data?.stripe?.account_id || '—',

        createdAt: new Date(data.createdAt).toLocaleDateString(),
        action: (
          <>
            <button
              onClick={() => handleDelete(data._id)}
              style={{
                background: '#DC2626', // red
                color: 'white',
                padding: '6px 12px',
                borderRadius: '6px',
                border: 'none',
                cursor: 'pointer',
                marginRight: '10px', // space between buttons
              }}
            >
              Delete
            </button>
            <button
              onClick={() => handleLoginAs(data._id)}
              style={{
                background: '#2563EB', // blue
                color: 'white',
                padding: '6px 12px',
                borderRadius: '6px',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Login As User
            </button>
          </>


        ),
      })),
    },
  }
}
